import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import { GltfLoading } from 'libs/rendering/gltf/components/loading';

export const LoadingViewer = withNamespaces()(
  observer(props => {
    const { width, noText, text } = props;
    const canvasWidth = width || '100%';

    return (
      <>
        <GltfLoading
          isLayoutCentered
          visible
          noText={noText}
          text={text}
          canvasWidth={canvasWidth}
          paused={false}
        />
      </>
    );
  }),
);

LoadingViewer.propTypes = {
  width: PropTypes.string,
};
